/* Alpha 3D Christmas ornament designer: four shapes, two sizes, two lines of text and festive patterns.
   Live 3D preview (three.js) plus a flat front view. On Add to cart it posts the product form itself
   with the design details, a PNG of the front and a ZIP of per-color STL print files.
   Markup and styles live in snippets/alpha-ornament-designer.liquid. */
(function () {
  var FIL = { Red: '#c8102e', Green: '#1b7a3e', White: '#f2f0eb', Gold: '#d4a53c', Silver: '#b8bcc2', Blue: '#2563eb', Black: '#1c1c1c' };
  // Default accent colors for each ornament color: text first, then decoration.
  var AUTO_TEXT = { Red: 'White', Green: 'White', White: 'Red', Gold: 'Red', Silver: 'Blue', Blue: 'White', Black: 'Gold' };
  var AUTO_DECO = { Red: 'Gold', Green: 'Gold', White: 'Green', Gold: 'Green', Silver: 'Red', Blue: 'Silver', Black: 'Silver' };
  var SHAPE_LABEL = { bauble: 'Bauble', star: 'Star', tree: 'Tree', stocking: 'Stocking' };
  var PATTERN_LABEL = { none: 'None', snow: 'Snowflakes', stars: 'Stars', dots: 'Dots' };
  var FONTS = {
    festive: { label: 'Festive', weight: '700', family: "'Mountains of Christmas', Georgia, serif" },
    script: { label: 'Script', weight: '400', family: "'Pacifico', 'Brush Script MT', cursive" },
    bold: { label: 'Bold', weight: '900', family: "'Arial Black', Arial, sans-serif" }
  };
  var CELL = 0.25;          // print grid in millimetres
  var BODY = 3, RAISE = 0.8; // ornament thickness and raised design height, mm
  var HOLE_R = 2.2, BORDER = 2.2, MIN_FONT = 4.5; // mm
  var RING_R = 7, RING_T = 0.55;

  function hexToRgb(hex) {
    return [parseInt(hex.slice(1, 3), 16), parseInt(hex.slice(3, 5), 16), parseInt(hex.slice(5, 7), 16)];
  }

  function arc(pts, cx, cy, r, a0, a1, n) {
    for (var k = 0; k <= n; k++) {
      var a = a0 + (a1 - a0) * k / n;
      pts.push([cx + r * Math.cos(a), cy + r * Math.sin(a)]);
    }
  }

  // Outlines at unit height, y up, counter-clockwise. hole is the hanger hole centre; lines are the two text boxes.
  var OUTLINES = {
    bauble: function () {
      var R = 0.43, cy = -0.07, cw = 0.1, capY = 0.4, t1 = Math.acos(cw / R), pts = [];
      arc(pts, 0, cy, R, Math.PI - t1, t1 + 2 * Math.PI, 120);
      arc(pts, 0, capY, cw, 0, Math.PI, 24);
      return { pts: pts, hole: [0, capY], lines: [{ x: 0, y: -0.04, w: 0.66, h: 0.14 }, { x: 0, y: -0.23, w: 0.5, h: 0.08 }] };
    },
    star: function () {
      var Ro = 1 / (1 + Math.cos(Math.PI / 5)), Ri = Ro * 0.5, cy = 0.5 - Ro, pts = [];
      for (var k = 0; k < 10; k++) {
        var a = Math.PI / 2 + k * Math.PI / 5, r = k % 2 ? Ri : Ro;
        pts.push([r * Math.cos(a), cy + r * Math.sin(a)]);
      }
      return { pts: pts, hole: [0, 0.3], lines: [{ x: 0, y: cy, w: 0.42, h: 0.11 }, { x: 0, y: cy - 0.13, w: 0.3, h: 0.06 }] };
    },
    tree: function () {
      var pts = [], nub = 0.065, top = 0.5 - nub;
      var right = [[0.24, 0.16], [0.15, 0.16], [0.34, -0.12], [0.24, -0.12], [0.44, -0.38], [0.09, -0.38], [0.09, -0.5]];
      // Right side from the trunk up to the hanger nub, over the nub, then the mirrored left side back down.
      for (var i = right.length - 1; i >= 0; i--) pts.push(right[i]);
      arc(pts, 0, top, nub, -0.56, Math.PI + 0.56, 24);
      for (var j = 0; j < right.length; j++) pts.push([-right[j][0], right[j][1]]);
      return { pts: pts, hole: [0, top], lines: [{ x: 0, y: -0.25, w: 0.54, h: 0.1 }, { x: 0, y: 0.01, w: 0.38, h: 0.07 }] };
    },
    stocking: function () {
      var pts = [[-0.3, 0.5], [-0.28, 0.32], [-0.31, -0.12], [-0.33, -0.22], [-0.32, -0.33], [-0.27, -0.42], [-0.18, -0.48], [-0.05, -0.5],
        [0.14, -0.5], [0.28, -0.47], [0.38, -0.4], [0.42, -0.3], [0.4, -0.2], [0.33, -0.12], [0.22, -0.08], [0.14, -0.02], [0.14, 0.32], [0.14, 0.5]];
      return { pts: pts, hole: [-0.23, 0.44], lines: [{ x: -0.025, y: 0.41, w: 0.3, h: 0.1 }, { x: -0.08, y: 0.1, w: 0.36, h: 0.07 }] };
    }
  };

  // Scale an outline to the ornament height in millimetres and centre it on its bounding box.
  function geometry(shape, size) {
    var o = OUTLINES[shape]();
    var minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
    o.pts.forEach(function (p) {
      minX = Math.min(minX, p[0]); maxX = Math.max(maxX, p[0]);
      minY = Math.min(minY, p[1]); maxY = Math.max(maxY, p[1]);
    });
    var sx = (minX + maxX) / 2, sy = (minY + maxY) / 2;
    var mm = function (p) { return [(p[0] - sx) * size, (p[1] - sy) * size]; };
    return {
      w: (maxX - minX) * size,
      h: (maxY - minY) * size,
      pts: o.pts.map(mm),
      hole: mm(o.hole).concat([HOLE_R]),
      lines: o.lines.map(function (b) { var c = mm([b.x, b.y]); return { x: c[0], y: c[1], w: b.w * size, h: b.h * size }; })
    };
  }

  // Triangles are stored as [nx, ny, nz, ax, ay, az, bx, by, bz, cx, cy, cz]; addTri fixes the winding to match n.
  function addTri(tris, a, b, c, n) {
    var ux = b[0] - a[0], uy = b[1] - a[1], uz = b[2] - a[2];
    var vx = c[0] - a[0], vy = c[1] - a[1], vz = c[2] - a[2];
    var cx = uy * vz - uz * vy, cy = uz * vx - ux * vz, cz = ux * vy - uy * vx;
    if (cx * n[0] + cy * n[1] + cz * n[2] < 0) { var t = b; b = c; c = t; }
    tris.push([n[0], n[1], n[2], a[0], a[1], a[2], b[0], b[1], b[2], c[0], c[1], c[2]]);
  }

  function addQuad(tris, a, b, c, d, n) {
    addTri(tris, a, b, c, n);
    addTri(tris, a, c, d, n);
  }

  // Closed solid from a grid of filled cells (row 0 at the top), between heights z0 and z1.
  function meshFromGrid(g, nx, ny, w, h, z0, z1, tris) {
    var X = function (i) { return i * CELL - w / 2; };
    var Y = function (j) { return h / 2 - j * CELL; };
    var on = function (i, j) { return i >= 0 && j >= 0 && i < nx && j < ny && g[j * nx + i] === 1; };
    for (var j = 0; j < ny; j++) {
      for (var i = 0; i < nx; i++) {
        if (!on(i, j)) continue;
        var xl = X(i), xr = X(i + 1), yt = Y(j), yb = Y(j + 1);
        addQuad(tris, [xl, yb, z1], [xr, yb, z1], [xr, yt, z1], [xl, yt, z1], [0, 0, 1]);
        addQuad(tris, [xl, yb, z0], [xr, yb, z0], [xr, yt, z0], [xl, yt, z0], [0, 0, -1]);
        if (!on(i, j - 1)) addQuad(tris, [xl, yt, z0], [xr, yt, z0], [xr, yt, z1], [xl, yt, z1], [0, 1, 0]);
        if (!on(i, j + 1)) addQuad(tris, [xl, yb, z0], [xr, yb, z0], [xr, yb, z1], [xl, yb, z1], [0, -1, 0]);
        if (!on(i - 1, j)) addQuad(tris, [xl, yb, z0], [xl, yt, z0], [xl, yt, z1], [xl, yb, z1], [-1, 0, 0]);
        if (!on(i + 1, j)) addQuad(tris, [xr, yb, z0], [xr, yt, z0], [xr, yt, z1], [xr, yb, z1], [1, 0, 0]);
      }
    }
  }

  // Majority filter over the grid: removes specks too small to print. Cells outside the ornament (0) are left alone.
  function modeFilter(src, w, h, rad) {
    var out = new Uint8Array(src), counts = [0, 0, 0, 0];
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var i = y * w + x, own = src[i];
        if (own === 0) continue;
        counts[1] = counts[2] = counts[3] = 0;
        for (var yy = Math.max(0, y - rad); yy <= Math.min(h - 1, y + rad); yy++) {
          for (var xx = Math.max(0, x - rad); xx <= Math.min(w - 1, x + rad); xx++) counts[src[yy * w + xx]]++;
        }
        var best = own;
        for (var v = 1; v < 4; v++) if (counts[v] > counts[best]) best = v;
        out[i] = best;
      }
    }
    return out;
  }

  function stlBlob(tris) {
    var buf = new ArrayBuffer(84 + tris.length * 50), dv = new DataView(buf);
    dv.setUint32(80, tris.length, true);
    for (var t = 0, o = 84; t < tris.length; t++, o += 50) {
      for (var q = 0; q < 12; q++) dv.setFloat32(o + q * 4, tris[t][q], true);
      dv.setUint16(o + 48, 0, true);
    }
    return new Blob([buf], { type: 'model/stl' });
  }

  // Small seeded random so the pattern stays put while the customer types.
  function rng(seed) {
    return function () {
      seed = (seed * 1664525 + 1013904223) % 4294967296;
      return seed / 4294967296;
    };
  }

  function init() {
    var box = document.getElementById('a3-ornament');
    var form = document.querySelector('form[data-type=add-to-cart-form]');
    if (!box || !form) return;

    var $ = function (sel) { return box.querySelector(sel); };
    var face = $('#ord-front');
    var work = document.createElement('canvas');
    var view3d = $('#ord-3d');
    var hint = $('#ord-hint');
    var line1 = $('#a3o-line1');
    var line2 = $('#a3o-line2');
    var border = $('#ord-border');
    var sizeNote = $('#ord-small');
    var err = $('.ord-err');
    var addButton = form.querySelector('[type=submit][name=add]');

    var state = {
      shape: 'bauble',
      base: optionValue('Color', 'Red'),
      size: parseInt(optionValue('Size', '3'), 10) === 4 ? 4 : 3,
      font: 'festive',
      pattern: 'snow',
      text: null,
      deco: null,
      view: '3d'
    };
    var G = null, PX = 10, W = 0, H = 0;
    var shapeMask, textMask, decoMask, idx;
    var three = null, busy = false;

    function optionValue(name, fallback) {
      var checked = document.querySelector('input[type=radio][name=' + name + ']:checked');
      return checked ? checked.value : fallback;
    }

    function textName() { return state.text || AUTO_TEXT[state.base] || 'White'; }
    function decoName() { return state.deco || AUTO_DECO[state.base] || 'Gold'; }
    function colorName(v) { return v === 1 ? state.base : v === 2 ? textName() : decoName(); }
    function hexOf(v) { return FIL[colorName(v)] || FIL.Black; }
    function sizeMm() { return state.size === 4 ? 102 : 76; }
    function fontCss(px) { var f = FONTS[state.font]; return f.weight + ' ' + px + 'px ' + f.family; }

    function toPx(p) { return [(p[0] + G.w / 2) * PX, (G.h / 2 - p[1]) * PX]; }

    function prepare() {
      work.width = W; work.height = H;
      var c = work.getContext('2d');
      c.clearRect(0, 0, W, H);
      return c;
    }

    function readMask() {
      var d = work.getContext('2d').getImageData(0, 0, W, H).data, m = new Uint8Array(W * H);
      for (var i = 0; i < m.length; i++) m[i] = d[i * 4 + 3] > 127 ? 1 : 0;
      return m;
    }

    function outlinePath(c) {
      c.beginPath();
      G.pts.forEach(function (p, i) { var q = toPx(p); if (i) c.lineTo(q[0], q[1]); else c.moveTo(q[0], q[1]); });
      c.closePath();
    }

    function holePath(c, extra) {
      var q = toPx(G.hole);
      c.beginPath();
      c.arc(q[0], q[1], (G.hole[2] + (extra || 0)) * PX, 0, Math.PI * 2);
    }

    function makeShapeMask() {
      var c = prepare();
      c.fillStyle = '#ffffff';
      outlinePath(c);
      c.fill();
      c.globalCompositeOperation = 'destination-out';
      holePath(c);
      c.fill();
      return readMask();
    }

    function lines() { return [line1.value.trim(), line2.value.trim()]; }

    // Each line is fitted to its box; returns true when any line had to shrink below a printable size.
    function makeTextMask() {
      var c = prepare(), tiny = false, t = lines();
      c.fillStyle = '#ffffff';
      c.textAlign = 'center';
      c.textBaseline = 'middle';
      G.lines.forEach(function (b, i) {
        if (!t[i]) return;
        var px = b.h * PX * 1.15;
        c.font = fontCss(px);
        while (c.measureText(t[i]).width > b.w * PX && px > 6) { px -= 1; c.font = fontCss(px); }
        if (px / PX < MIN_FONT) tiny = true;
        var q = toPx([b.x, b.y]);
        c.fillText(t[i], q[0], q[1]);
      });
      sizeNote.hidden = !tiny;
      return readMask();
    }

    function glyph(c, kind, x, y, r) {
      var lw = Math.max(0.9 * PX, r * 0.28);
      if (kind === 'dots') {
        c.beginPath();
        c.arc(x, y, r * 0.42, 0, Math.PI * 2);
        c.fill();
      } else if (kind === 'stars') {
        c.beginPath();
        for (var k = 0; k < 10; k++) {
          var a = -Math.PI / 2 + k * Math.PI / 5, rr = k % 2 ? r * 0.45 : r;
          if (k) c.lineTo(x + rr * Math.cos(a), y + rr * Math.sin(a)); else c.moveTo(x + rr * Math.cos(a), y + rr * Math.sin(a));
        }
        c.closePath();
        c.fill();
      } else {
        c.lineWidth = lw;
        c.lineCap = 'round';
        for (var s = 0; s < 3; s++) {
          var ang = s * Math.PI / 3, dx = Math.cos(ang), dy = Math.sin(ang);
          c.beginPath();
          c.moveTo(x - dx * r, y - dy * r);
          c.lineTo(x + dx * r, y + dy * r);
          c.stroke();
          [-1, 1].forEach(function (end) {
            var bx = x + dx * r * 0.55 * end, by = y + dy * r * 0.55 * end;
            [-1, 1].forEach(function (side) {
              var ba = ang + (end > 0 ? 0 : Math.PI) + side * 0.75;
              c.beginPath();
              c.moveTo(bx, by);
              c.lineTo(bx + Math.cos(ba) * r * 0.38, by + Math.sin(ba) * r * 0.38);
              c.stroke();
            });
          });
        }
      }
    }

    // Border ring inside the outline, plus a scatter of small motifs that keeps clear of the text and the hanger.
    function makeDecoMask() {
      var c = prepare(), t = lines(), S = sizeMm();
      c.fillStyle = '#ffffff';
      c.strokeStyle = '#ffffff';
      var inset = border.checked ? BORDER : 0;
      if (border.checked) {
        c.save();
        outlinePath(c);
        c.clip();
        c.lineWidth = BORDER * 2 * PX;
        c.lineJoin = 'round';
        outlinePath(c);
        c.stroke();
        c.restore();
      }
      if (state.pattern !== 'none') {
        var r = S * 0.04, gap = S * 0.15, rand = rng(7), pad = r + inset + 1.2;
        var keepOut = G.lines.filter(function (b, i) { return !!t[i]; });
        for (var gy = -G.h / 2; gy < G.h / 2 + gap; gy += gap * 0.87) {
          var row = Math.round((gy + G.h / 2) / (gap * 0.87));
          for (var gx = -G.w / 2 + (row % 2 ? gap / 2 : 0); gx < G.w / 2 + gap; gx += gap) {
            var x = gx + (rand() - 0.5) * gap * 0.35, y = gy + (rand() - 0.5) * gap * 0.35;
            if (!fits(x, y, pad)) continue;
            if (Math.hypot(x - G.hole[0], y - G.hole[1]) < G.hole[2] + pad + 1) continue;
            var blocked = keepOut.some(function (b) { return Math.abs(x - b.x) < b.w / 2 + pad && Math.abs(y - b.y) < b.h / 2 + pad; });
            if (blocked) continue;
            var q = toPx([x, y]);
            glyph(c, state.pattern, q[0], q[1], r * PX * (0.85 + rand() * 0.3));
          }
        }
      }
      var m = readMask();
      for (var i = 0; i < m.length; i++) if (!shapeMask[i]) m[i] = 0;
      return m;
    }

    // True when a circle of radius pad (mm) around x, y lies inside the ornament.
    function fits(x, y, pad) {
      for (var k = 0; k < 8; k++) {
        var a = k * Math.PI / 4, q = toPx([x + Math.cos(a) * pad, y + Math.sin(a) * pad]);
        var px = Math.round(q[0]), py = Math.round(q[1]);
        if (px < 0 || py < 0 || px >= W || py >= H || !shapeMask[py * W + px]) return false;
      }
      var cq = toPx([x, y]), cx = Math.round(cq[0]), cy = Math.round(cq[1]);
      return cx >= 0 && cy >= 0 && cx < W && cy < H && shapeMask[cy * W + cx] === 1;
    }

    function rebuildAll() {
      G = geometry(state.shape, sizeMm());
      PX = 1000 / Math.max(G.w, G.h);
      W = Math.ceil(G.w * PX); H = Math.ceil(G.h * PX);
      shapeMask = makeShapeMask();
      rebuildDesign();
      if (three) three.rebuild();
    }

    function rebuildDesign() {
      textMask = makeTextMask();
      decoMask = makeDecoMask();
      compose();
    }

    function compose() {
      var n = W * H;
      if (!idx || idx.length !== n) idx = new Uint8Array(n);
      for (var i = 0; i < n; i++) idx[i] = !shapeMask[i] ? 0 : textMask[i] ? 2 : decoMask[i] ? 3 : 1;
      if (face.width !== W || face.height !== H) { face.width = W; face.height = H; }
      var ctx = face.getContext('2d'), out = ctx.createImageData(W, H), d = out.data;
      var rgb = [null, hexToRgb(hexOf(1)), hexToRgb(hexOf(2)), hexToRgb(hexOf(3))];
      for (var y = 0; y < H; y++) {
        var shade = y % 3 === 0 ? 0.94 : 1; // faint layer lines, like a real print
        for (var x = 0; x < W; x++) {
          var k = y * W + x, v = idx[k], j = k * 4;
          if (!v) { d[j + 3] = 0; continue; }
          d[j] = rgb[v][0] * shade;
          d[j + 1] = rgb[v][1] * shade;
          d[j + 2] = rgb[v][2] * shade;
          d[j + 3] = 255;
        }
      }
      ctx.putImageData(out, 0, 0);
      if (three) three.refresh();
    }

    function swatch(name, hex, selected, onPick, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ord-sw' + (selected ? ' is-on' : '');
      b.style.setProperty('--c', hex);
      b.title = label || name;
      b.setAttribute('aria-label', label || name);
      b.setAttribute('aria-pressed', selected ? 'true' : 'false');
      b.addEventListener('click', onPick);
      return b;
    }

    function renderColorUI() {
      [['#ord-text-color', 'text', AUTO_TEXT, textName, '#ord-text-name'], ['#ord-deco-color', 'deco', AUTO_DECO, decoName, '#ord-deco-name']].forEach(function (cfg) {
        var list = $(cfg[0]), key = cfg[1];
        list.innerHTML = '';
        var auto = swatch('Auto', FIL[cfg[2][state.base]], !state[key], function () { state[key] = null; renderColorUI(); compose(); }, 'Auto, matches the ornament color');
        auto.classList.add('ord-sw--auto');
        auto.textContent = 'A';
        list.appendChild(auto);
        Object.keys(FIL).forEach(function (name) {
          list.appendChild(swatch(name, FIL[name], state[key] === name, function () { state[key] = name; renderColorUI(); compose(); }));
        });
        $(cfg[4]).textContent = cfg[3]() + (state[key] ? '' : ' (auto)');
      });
    }

    function setupThree() {
      var T = window.THREE, renderer;
      try {
        renderer = new T.WebGLRenderer({ antialias: true, alpha: true });
      } catch (e) {
        return null;
      }
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      renderer.outputEncoding = T.sRGBEncoding;
      view3d.appendChild(renderer.domElement);

      var scene = new T.Scene();
      var camera = new T.PerspectiveCamera(30, 1, 1, 2000);
      scene.add(new T.HemisphereLight(0xffffff, 0x9a948a, 0.95));
      var sun = new T.DirectionalLight(0xffffff, 0.75);
      sun.position.set(50, 80, 120);
      scene.add(sun);
      var rim = new T.DirectionalLight(0xffffff, 0.45);
      rim.position.set(-40, 40, -120);
      scene.add(rim);

      var group = new T.Group();
      scene.add(group);
      var tex = new T.CanvasTexture(face);
      tex.encoding = T.sRGBEncoding;
      tex.anisotropy = 4;
      var bodyMat = new T.MeshStandardMaterial({ roughness: 0.55, metalness: 0 });
      var faceMat = new T.MeshStandardMaterial({ map: tex, roughness: 0.5, transparent: true });
      var ringMat = new T.MeshStandardMaterial({ color: 0xd4a53c, metalness: 0.85, roughness: 0.3 });
      var parts = [];

      function outlineShape() {
        var shape = new T.Shape();
        G.pts.forEach(function (p, i) { if (i) shape.lineTo(p[0], p[1]); else shape.moveTo(p[0], p[1]); });
        var hole = new T.Path();
        hole.absarc(G.hole[0], G.hole[1], G.hole[2], 0, Math.PI * 2, true);
        shape.holes.push(hole);
        return shape;
      }

      function rebuild() {
        parts.forEach(function (p) {
          group.remove(p);
          p.traverse(function (o) { if (o.geometry) o.geometry.dispose(); });
        });
        var bevel = 0.35, depth = BODY - 2 * bevel;
        var bodyGeo = new T.ExtrudeGeometry(outlineShape(), { depth: depth, bevelEnabled: true, bevelThickness: bevel, bevelSize: bevel, bevelSegments: 3, curveSegments: 48 });
        bodyGeo.translate(0, 0, -depth / 2);
        var body = new T.Mesh(bodyGeo, bodyMat);
        // ShapeGeometry UVs are in millimetres; map them onto the 0..1 face texture.
        var faceGeo = new T.ShapeGeometry(outlineShape(), 48), uv = faceGeo.attributes.uv;
        for (var i = 0; i < uv.count; i++) uv.setXY(i, uv.getX(i) / G.w + 0.5, uv.getY(i) / G.h + 0.5);
        uv.needsUpdate = true;
        var front = new T.Mesh(faceGeo, faceMat);
        front.position.z = depth / 2 + bevel + 0.02;
        // Gold hanger loop through the hole.
        var ring = new T.Mesh(new T.TorusGeometry(RING_R, RING_T, 16, 56), ringMat);
        ring.rotation.y = Math.PI / 2;
        ring.position.set(G.hole[0], G.hole[1] + RING_R - G.hole[2] * 0.6, 0);
        parts = [body, front, ring];
        parts.forEach(function (p) { group.add(p); });
        var topY = Math.max(G.h / 2, ring.position.y + RING_R + RING_T);
        group.position.set(0, -(topY - G.h / 2) / 2, 0);
        camera.position.set(0, 0, Math.max(G.w, topY + G.h / 2) * 2.4);
        camera.lookAt(0, 0, 0);
        refresh();
      }

      function refresh() {
        bodyMat.color.copy(new T.Color(FIL[state.base] || FIL.Red).convertSRGBToLinear());
        tex.needsUpdate = true;
      }

      function resize() {
        var r = view3d.getBoundingClientRect();
        if (!r.width || !r.height) return;
        renderer.setSize(r.width, r.height, false);
        camera.aspect = r.width / r.height;
        camera.updateProjectionMatrix();
      }

      // Drag to spin; when idle it sways like it is hanging on a branch.
      var rotY = -0.35, rotX = 0.08, dragging = false, lastX = 0, lastY = 0, lastTouch = 0;
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var canvas = renderer.domElement;
      canvas.addEventListener('pointerdown', function (e) {
        dragging = true; lastX = e.clientX; lastY = e.clientY;
        if (canvas.setPointerCapture) canvas.setPointerCapture(e.pointerId);
      });
      canvas.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        rotY += (e.clientX - lastX) * 0.012;
        rotX = Math.max(-0.8, Math.min(0.8, rotX + (e.clientY - lastY) * 0.008));
        lastX = e.clientX; lastY = e.clientY; lastTouch = Date.now();
      });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (t) {
        canvas.addEventListener(t, function () { dragging = false; lastTouch = Date.now(); });
      });

      var visible = true;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }).observe(view3d);
      }
      function loop(now) {
        requestAnimationFrame(loop);
        if (!visible || state.view !== '3d') return;
        var swing = 0;
        if (!dragging && !still && Date.now() - lastTouch > 2500) {
          var base = Math.round(rotY / Math.PI) * Math.PI;
          rotY += (base + Math.sin(now / 1900) * 0.55 - rotY) * 0.02;
          rotX += (0.08 - rotX) * 0.03;
          swing = Math.sin(now / 1300) * 0.035;
        }
        group.rotation.set(rotX, rotY, swing);
        renderer.render(scene, camera);
      }

      if ('ResizeObserver' in window) new ResizeObserver(resize).observe(view3d);
      window.addEventListener('resize', resize);
      resize();
      rebuild();
      requestAnimationFrame(loop);
      return { rebuild: rebuild, refresh: refresh };
    }

    function setView(view) {
      state.view = three ? view : 'front';
      view3d.hidden = state.view !== '3d';
      face.hidden = state.view !== 'front';
      hint.textContent = state.view === '3d' ? 'Drag to spin' : 'Front view';
      box.querySelectorAll('#ord-toggle button').forEach(function (b) { b.classList.toggle('is-on', b.dataset.view === state.view); });
    }

    function chips(sel, onPick) {
      $(sel).addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        $(sel).querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        onPick(b);
      });
    }

    function showError(msg) {
      err.textContent = msg;
      err.hidden = false;
      err.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    // Load the web fonts before drawing with them, so the preview (and the print) uses the real letters.
    function useFont() {
      var f = FONTS[state.font];
      if (!document.fonts || !document.fonts.load) { rebuildDesign(); return; }
      document.fonts.load(f.weight + ' 40px ' + f.family).then(rebuildDesign, rebuildDesign);
    }

    // One STL per filament color, ready to load together as a multi-part object in the slicer.
    function buildPrintZip() {
      if (!window.JSZip || !window.THREE) return Promise.resolve(null);
      var T = window.THREE, nx = Math.round(G.w / CELL), ny = Math.round(G.h / CELL);
      var grid = new Uint8Array(nx * ny);
      for (var iy = 0; iy < ny; iy++) {
        var py = Math.min(H - 1, Math.floor((iy + 0.5) * CELL * PX));
        for (var ix = 0; ix < nx; ix++) grid[iy * nx + ix] = idx[py * W + Math.min(W - 1, Math.floor((ix + 0.5) * CELL * PX))];
      }
      grid = modeFilter(grid, nx, ny, 1);
      var zip = new window.JSZip(), list = [], n = 1;
      function add(label, color, tris) {
        if (!tris.length) return;
        var name = n + '-' + label + '-' + color.toLowerCase() + '.stl';
        zip.file(name, stlBlob(tris));
        list.push('  ' + name + '  ->  ' + color + ' filament');
        n++;
      }
      var shape = new T.Shape();
      G.pts.forEach(function (p, i) { if (i) shape.lineTo(p[0], p[1]); else shape.moveTo(p[0], p[1]); });
      var hole = new T.Path();
      hole.absarc(G.hole[0], G.hole[1], G.hole[2], 0, Math.PI * 2, true);
      shape.holes.push(hole);
      var geo = new T.ExtrudeGeometry(shape, { depth: BODY, bevelEnabled: false, curveSegments: 64 });
      if (geo.index) geo = geo.toNonIndexed();
      var p = geo.attributes.position.array, body = [];
      for (var k = 0; k < p.length; k += 9) {
        var ux = p[k + 3] - p[k], uy = p[k + 4] - p[k + 1], uz = p[k + 5] - p[k + 2];
        var vx = p[k + 6] - p[k], vy = p[k + 7] - p[k + 1], vz = p[k + 8] - p[k + 2];
        var cx = uy * vz - uz * vy, cy = uz * vx - ux * vz, cz = ux * vy - uy * vx, len = Math.hypot(cx, cy, cz) || 1;
        body.push([cx / len, cy / len, cz / len, p[k], p[k + 1], p[k + 2], p[k + 3], p[k + 4], p[k + 5], p[k + 6], p[k + 7], p[k + 8]]);
      }
      geo.dispose();
      add('body', state.base, body);
      // Text and decoration share one part when they are the same color.
      var groups = {};
      [2, 3].forEach(function (v) { (groups[colorName(v)] = groups[colorName(v)] || []).push(v); });
      Object.keys(groups).forEach(function (color) {
        var vals = groups[color], m = new Uint8Array(grid.length), any = false;
        for (var i = 0; i < grid.length; i++) if (vals.indexOf(grid[i]) !== -1) { m[i] = 1; any = true; }
        if (!any) return;
        var tris = [];
        meshFromGrid(m, nx, ny, G.w, G.h, BODY, BODY + RAISE, tris);
        add(vals.length > 1 ? 'design' : vals[0] === 2 ? 'text' : 'decoration', color, tris);
      });
      var t = lines();
      var readme = [
        'Alpha 3D Printing Co. Christmas ornament print files',
        '',
        'Shape: ' + SHAPE_LABEL[state.shape] + ' (' + G.w.toFixed(1) + ' x ' + G.h.toFixed(1) + ' mm, ' + state.size + ' in tall)',
        'Line 1: ' + (t[0] || 'none') + '   Line 2: ' + (t[1] || 'none') + '   Font: ' + FONTS[state.font].label,
        'Units: millimetres.',
        '',
        'Load all STL files at once in Bambu Studio, OrcaSlicer or PrusaSlicer and choose to load',
        'them as a single object with multiple parts, then set each part to its filament:',
        list.join('\n'),
        '',
        'Layers: body 0-' + BODY + ' mm, raised design ' + BODY + '-' + (BODY + RAISE) + ' mm. Hanger hole ' + (HOLE_R * 2) + ' mm.'
      ].join('\n');
      zip.file('README.txt', readme);
      return zip.generateAsync({ type: 'blob', compression: 'DEFLATE' });
    }

    function setBusy(on) {
      busy = on;
      if (!addButton) return;
      addButton.classList.toggle('loading', on);
      if (on) { addButton.setAttribute('aria-disabled', 'true'); } else { addButton.removeAttribute('aria-disabled'); }
    }

    function post(fd) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: fd })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok && !data.status, data: data }; }); });
    }

    function formData(png, zipBlob) {
      var t = lines(), fd = new FormData(form), deco = [];
      if (state.pattern !== 'none') deco.push(PATTERN_LABEL[state.pattern]);
      if (border.checked) deco.push('border');
      fd.append('properties[Shape]', SHAPE_LABEL[state.shape]);
      if (t[0]) fd.append('properties[Line 1]', t[0]);
      if (t[1]) fd.append('properties[Line 2]', t[1]);
      if (t[0] || t[1]) fd.append('properties[Font]', FONTS[state.font].label);
      fd.append('properties[Decoration]', deco.length ? deco.join(' + ') : 'None');
      var colors = ['Ornament: ' + state.base];
      if (t[0] || t[1]) colors.push('Text: ' + textName());
      if (deco.length) colors.push('Decoration: ' + decoName());
      fd.append('properties[Colors]', colors.join(', '));
      if (png) fd.append('properties[Design preview]', new File([png], 'ornament-design.png', { type: 'image/png' }));
      if (zipBlob) fd.append('properties[Print files]', new File([zipBlob], 'ornament-print-files.zip', { type: 'application/zip' }));
      return fd;
    }

    function addToCart(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (busy) return;
      err.hidden = true;
      setBusy(true);
      var png = null;
      new Promise(function (resolve) { face.toBlob(resolve, 'image/png'); })
        .then(function (blob) { png = blob; return buildPrintZip().catch(function () { return null; }); })
        // If the print files are refused for any reason, still add the ornament with its design.
        .then(function (zipBlob) { return post(formData(png, zipBlob)).then(function (r) { return r.ok || !zipBlob ? r : post(formData(png, null)); }); })
        .then(function (r) {
          if (!r.ok) {
            setBusy(false);
            showError(r.data.description || 'Something went wrong adding this to your cart. Please try again.');
            return;
          }
          window.location.href = '/cart';
        })
        .catch(function () {
          setBusy(false);
          showError('Your ornament could not be added. Check your connection and try again.');
        });
    }

    // Wire up controls.
    $('#ord-toggle').addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (b) setView(b.dataset.view);
    });
    chips('#ord-shape', function (b) { state.shape = b.dataset.shape; rebuildAll(); });
    chips('#ord-font', function (b) { state.font = b.dataset.font; useFont(); });
    chips('#ord-pattern', function (b) { state.pattern = b.dataset.pattern; decoMask = makeDecoMask(); compose(); });
    border.addEventListener('change', function () { decoMask = makeDecoMask(); compose(); });
    [[line1, '#a3o-count1'], [line2, '#a3o-count2']].forEach(function (pair) {
      pair[0].addEventListener('input', function () {
        $(pair[1]).textContent = pair[0].maxLength - pair[0].value.length;
        rebuildDesign();
      });
    });
    $('#ord-ideas').addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      line2.value = b.dataset.text;
      line2.dispatchEvent(new Event('input'));
    });
    document.addEventListener('change', function (e) {
      if (e.target.name === 'Color' && FIL[e.target.value]) { state.base = e.target.value; renderColorUI(); compose(); }
      if (e.target.name === 'Size') { state.size = parseInt(e.target.value, 10) === 4 ? 4 : 3; rebuildAll(); }
    });

    // Capture phase on document runs before the theme's and any app's handlers on the button or form.
    document.addEventListener('click', function (e) {
      if (addButton && e.target.closest && e.target.closest('[type=submit][name=add]') === addButton) addToCart(e);
    }, true);
    document.addEventListener('submit', function (e) {
      if (e.target === form) addToCart(e);
    }, true);

    renderColorUI();
    rebuildAll();
    if (window.THREE) { three = setupThree(); }
    setView(three ? '3d' : 'front');
    if (!three) $('#ord-toggle').hidden = true;
    useFont();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
